import { call, put, takeLeading, } from 'redux-saga/effects'
import {
  FETCH_PROFILE_SUCCESS,
  IS_LOGIN_REQUESTED,
  IS_LOGIN_SUCCESS,
  LOGIN_FAILED,
  LOGIN_REQUESTED,
  LOGOUT_FAILED,
  LOGOUT_REQUESTED,
  LOGOUT_SUCCESS,
} from "./actionTypes";
import { ApiResponse, sessionApi } from './../../api/'
import { LoginRequestAction } from "./actions";
import { MENU_CHANGE_REUQESETED } from "../common/actionTypes";
import { MenuList } from "../common";

export function* login(action: LoginRequestAction) {
  try {
    const response: ApiResponse<any | undefined> = yield call(sessionApi.login, action.payload);
    if (response.data) {
      yield put({
        type: IS_LOGIN_SUCCESS,
        payload: response.data[0],
      })
    }
  }
  catch (e) {
    yield put({ type: LOGIN_FAILED })
  }
}

export function* logout(action: any) {
  try {
    yield put({
      type: LOGOUT_SUCCESS,
    })

    yield put({
      type: MENU_CHANGE_REUQESETED,
      payload: {
        selectedTab: MenuList.Home,
      }
    })
  }
  catch (e) {
    yield put({ type: LOGOUT_FAILED })
  }
}

export function* isLogin(action: any) {
  try {
    const response: ApiResponse<any | undefined> = yield call(sessionApi.getProfile)
    if (response.data) {
      yield put({
        type: FETCH_PROFILE_SUCCESS,
        payload: response.data[0],
      })
      yield put({
        type: IS_LOGIN_SUCCESS,
        payload: true,
      })
    }
    else {
      yield put({
        type: FETCH_PROFILE_SUCCESS,
        payload: {},
      })
      yield put({
        type: IS_LOGIN_SUCCESS,
        payload: false,
      })
    }
  }
  catch (e) {
    yield put({ type: LOGIN_FAILED })
  }
}
export default function* commonSagas() {
  yield takeLeading(LOGIN_REQUESTED, login)
  yield takeLeading(LOGOUT_REQUESTED, logout)
  yield takeLeading(IS_LOGIN_REQUESTED, isLogin)
}
